export const AffiliationConstants =  {
  All : 'All',
  P: 'P',
  AFFILIATIONS:"affiliations"
}
